export const mediaPageInitialState = {
  file: null as File,
  error: null as string,
  isUploading: false,
  isLoading: false,
  linkUrl: '',
  linkName: '',
  isLinkUrlValid: true,
  isSavingLink: false
}

export type MediaPageState = typeof mediaPageInitialState
